const regex = {
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-1]\d{2}\.[0-1]\d{2}\.[0-1]\d{2}\.[0-1]\d{2}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/,
  number: /^\d+$/,
  idCard: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  name: /^[a-zA-Z ']{3,50}$/,
  username: /^[a-zA-Z][a-zA-Z0-9-_]{3,20}$/,
  phoneNumber: /^\+*[0-9]{11,15}$/,
  postCode: /^\+*[0-9]{5}$/,
};

export default regex;
